export default __webpack_public_path__ + "static/media/times-2.001cdf24.svg";